import {Component, Injector} from '@angular/core';
import {Projeto} from "../../../../domain/Projeto";
import {AbstractListOrmComponent} from "../../AbstractListOrmComponent";
import LocalDataSource from "../../../../data-sources/LocalDataSource";
import {Grupo} from "../../../../domain/enums";
import {FaunaDataSource} from "../../../../services/persist/FaunaDataSource";

@Component({
  selector: 'app-list-projeto',
  templateUrl: './list-projeto.component.html',
  styleUrls: ['./list-projeto.component.scss'],
})
export class ListProjetoComponent extends AbstractListOrmComponent<Projeto>{
  agenciavel = true
  grupos = Object.values(Grupo)
  override relations = ["local","metodologias"]
  override select = ['id','nome','inicio','fim','local.nome','metodologias']


  constructor(injector: Injector, ds: FaunaDataSource) {
    super(injector,  ds.getRepository(Projeto))
  }
  retornaGrupos(projeto: Projeto): string {
    const siglas =  projeto.metodologias?.flatMap(m => m.grupos)
    const unicos = [...new Set(siglas)]
    return unicos.join(' - ')
  }


}
